import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type FindTutorInactiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function FindTutorInactiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: FindTutorInactiveIconProps) {
  return (
    <Svg
      width={29}
      height={29}
      viewBox="0 0 29 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M19.163 3.708H11.97a5.995 5.995 0 00-5.995 5.995v9.593a5.995 5.995 0 005.995 5.995h7.194a5.995 5.995 0 005.996-5.995V9.703a5.995 5.995 0 00-5.995-5.995zM4.175 10.304h3.597M4.175 18.696h3.597"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
      <Path
        d="M20.115 20.035c0-1.928-2.15-3.495-4.077-3.495-1.929 0-4.078 1.567-4.078 3.495M16.037 13.762a2.74 2.74 0 100-5.479 2.74 2.74 0 000 5.48z"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default FindTutorInactiveIcon;
